/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLinkDto } from '../../models/create-link-dto';
import { Link } from '../../models/link';

export interface LinksControllerCreate$Params {
      body: CreateLinkDto
}

export function linksControllerCreate(http: HttpClient, rootUrl: string, params: LinksControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Link>> {
  const rb = new RequestBuilder(rootUrl, linksControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Link>;
    })
  );
}

linksControllerCreate.PATH = '/links';
